/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip } from "@material-ui/core";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsRadioButton from "app/common/form/GlobitsRadioButton";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import {
  INTEREST_RATE_TYPE,
  PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT,
  PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT,
  PAYMENT_METHOD_CHARACTERISTIC_LOYALTY,
  PAYMENT_METHOD_CHARACTERISTIC_POS,
  PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
  PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE,
  PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD,
  TYPE_GLOBAL_PROPOTIES_BANK,
  TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
  TYPE_GLOBAL_PROPOTIES_POS_LIST,
  TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
} from "app/common/LocalConst";
import { PAYMENT_METHOD_CODES_REQUIRED_INTEREST_RATE } from "app/appConfig";
import { calcPaymentRemainder, roundVnd } from "app/common/LocalFunction";
import { pagingExtGlobalProperty } from "app/services/GlobalPropertyService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useEffect } from "react";
import SelectCardFeePopup from "../Popup/SelectCardFeePopup";
import SelectDepositMoneyFeePopup from "../Popup/SelectDepositMoneyFeePopup";
import SelectLoyaltyPointPopup from "../Popup/SelectLoyaltyPointPopup";
import SelectTreatmentRetainPopup from "../Popup/SelectTreatmentRetainPopup";
import SelectInterestRatePopup from "../Popup/SelectInterestRatePopup";
// import SelectCardFeePopup from "../Popup/SelectCardFeePopup";
function TotalOfVoucherBy({
  nameSpace,
  disabled,
  moneyAfterDiscount,
  listPaymentMethod,
  listStk,
  listPos,
  patientId,
  listHomecredit,
  listPos_tragop,
}) {
  const { values, setFieldValue, errors } = useFormikContext();

  const withNameSpace = (name, index) => {
    return `${nameSpace}[${index}].${name}`;
  };

  useEffect(() => {
    let sum =
      values?.voucherPaymentMethods?.length > 0 &&
      values?.voucherPaymentMethods?.reduce((acc, el) => {
        if (el?.isCal) {
          return acc + roundVnd(el?.totalOfMethod);
        }
        return acc;
      }, 0);

    let voucherPaymentMethods = values?.voucherPaymentMethods?.map((el) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        let amountBank = calcPaymentRemainder(moneyAfterDiscount, sum);
        return {
          ...el,
          totalOfMethod: amountBank,
          bankName: el?.paymentBank?.propertyName,
          bankAccountNumber: el?.paymentBank?.property,
          ...(amountBank <= 0
            ? {
              interestRateType: null,
              interestRate: 0,
              periodMonths: 0,
              interestRatePeriodId: null,
            }
            : {}),
        };
      } else if (el?.isCal) {
        //tại 2 hàm submit của thẻ + tiền cọc có truyền biến này = true để tránh tính lại tiền dồn lại ck
        return {
          ...el,
          isCal: false,
        };
      }
      return {
        ...el,
        totalOfMethod: 0,
        interestRateType: null,
        interestRate: 0,
        periodMonths: 0,
        interestRatePeriodId: null,
      };
    });

    setFieldValue("voucherPaymentMethods", voucherPaymentMethods);
  }, [moneyAfterDiscount]);

  const handleChangeTotalOfMethod = (e, item, index) => {
    let value = roundVnd(e?.target?.value);

    //set value
    setFieldValue(withNameSpace("totalOfMethod", index), value);
    let newVoucherPaymentMethods =
      values?.voucherPaymentMethods?.length > 0 &&
      values?.voucherPaymentMethods?.map((el, ind) => {
        if (index === ind) return { ...el, totalOfMethod: value };
        else return el;
      });

    let sum =
      newVoucherPaymentMethods?.length > 0 &&
      newVoucherPaymentMethods?.reduce((acc, el) => {
        if (
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
        ) {
          return acc;
        }
        return acc + roundVnd(el?.totalOfMethod);
      }, 0);

    //if method bank then set stk account bank
    if (
      item?.characteristic ===
      PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
    ) {
      const paymentBank = getIn(values, withNameSpace("paymentBank", index));
      if (!paymentBank) {
        setFieldValue(withNameSpace("paymentBank", index), listStk?.[0]);
      }
    }

    if (item?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS) {
      setFieldValue(withNameSpace("paymentBank", index), listPos?.[0]);
    }
    if (item?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT) {
      setFieldValue(withNameSpace("paymentBank", index), listHomecredit?.[0]);
    }
    if (
      item?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP
    ) {
      setFieldValue(withNameSpace("paymentBank", index), listPos_tragop?.[0]);
    }
    //if methodnot bank :re calculate totalOfMethod
    values?.voucherPaymentMethods?.forEach((el, idx) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        let amountBank = calcPaymentRemainder(moneyAfterDiscount, sum);
        setFieldValue(withNameSpace("totalOfMethod", idx), amountBank);
        if (amountBank <= 0) {
          setFieldValue(withNameSpace("interestRateType", idx), null);
          setFieldValue(withNameSpace("interestRate", idx), 0);
          setFieldValue(withNameSpace("periodMonths", idx), 0);
          setFieldValue(withNameSpace("interestRatePeriodId", idx), null);
        }
      } else if (index === idx && +value <= 0) {
        setFieldValue(withNameSpace("interestRateType", idx), null);
        setFieldValue(withNameSpace("interestRate", idx), 0);
        setFieldValue(withNameSpace("periodMonths", idx), 0);
        setFieldValue(withNameSpace("interestRatePeriodId", idx), null);
      }
    });
  };

  return (
    <div
      style={{ overflow: "auto", scrollbarWidth: "thin", padding: "0" }}
      className="table-root table-concept-datatype"
    >
      <div style={{ maxHeight: "60vh", padding: "0" }}>
        <table className="table-container table-layout-fixed">
          <thead className="row-table-header">
            <tr>
              <th width="35%" style={{ color: "#4276a4" }}>
                HTTT
              </th>
              <th width="40%" style={{ color: "#4276a4" }}>
                Số tiền
              </th>
              <th width="25%" style={{ color: "#4276a4" }}>
                Kỳ hạn lãi suất
              </th>
              {/* <th style={{ color: "#4276a4" }}>Ghi chú</th> */}
            </tr>
          </thead>
          <tbody>
            {listPaymentMethod?.length > 0 &&
              listPaymentMethod?.map((el, index) =>
                el?.isUsing ? (
                  <>
                    <tr key={index}>
                      <td>
                        <div className="flex align-center">
                          {el?.characteristic !==
                            PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD &&
                            el?.characteristic !==
                            PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT &&
                            el?.code !==
                            PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE &&
                            el?.code !==
                            PAYMENT_METHOD_CHARACTERISTIC_LOYALTY && (
                              <GlobitsRadioButton
                                name={"totalRadio"}
                                value={el + 1}
                                type="radio"
                                checked={values?.totalRadio === index + 1}
                                onChange={(e) => {
                                  // nếu là dùng thẻ thì ko xử lí
                                  if (
                                    el?.characteristic ===
                                    PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
                                  ) {
                                    return;
                                  }
                                  setFieldValue("totalRadio", index + 1);
                                  let voucherPaymentMethods =
                                    values?.voucherPaymentMethods?.map(
                                      (el, stt) => {
                                        if (stt === index) {
                                          return {
                                            ...el,
                                            totalOfMethod: moneyAfterDiscount,
                                          };
                                        } else {
                                          return {
                                            ...el,
                                            totalOfMethod: 0,
                                            interestRateType: null,
                                            interestRate: 0,
                                            periodMonths: 0,
                                            interestRatePeriodId: null,
                                          };
                                        }
                                      }
                                    );
                                  setFieldValue(
                                    "voucherPaymentMethods",
                                    voucherPaymentMethods
                                  );

                                  if (
                                    el?.characteristic ===
                                    PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT &&
                                    !el?.paymentBank
                                  ) {
                                    setFieldValue(
                                      withNameSpace("paymentBank", index),
                                      listStk?.[0]
                                    );
                                  }
                                  if (
                                    el?.characteristic ===
                                    PAYMENT_METHOD_CHARACTERISTIC_POS
                                  ) {
                                    setFieldValue(
                                      withNameSpace("paymentBank", index),
                                      listHomecredit?.[0]
                                    );
                                    setFieldValue(
                                      withNameSpace("bankAccountNumber", index),
                                      listHomecredit?.[0]?.property
                                    );
                                    setFieldValue(
                                      withNameSpace("bankName", index),
                                      listHomecredit?.[0]?.propertyName
                                    );
                                  }

                                  if (
                                    el?.characteristic ===
                                    PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT
                                  ) {
                                    setFieldValue(
                                      withNameSpace("paymentBank", index),
                                      listHomecredit?.[0]
                                    );
                                    setFieldValue(
                                      withNameSpace("bankAccountNumber", index),
                                      listHomecredit?.[0]?.property
                                    );
                                    setFieldValue(
                                      withNameSpace("bankName", index),
                                      listHomecredit?.[0]?.propertyName
                                    );
                                  }

                                  if (
                                    el?.characteristic ===
                                    PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP
                                  ) {
                                    console.log(
                                      "listPos_tragop",
                                      listPos_tragop
                                    );
                                    setFieldValue(
                                      withNameSpace("paymentBank", index),
                                      listPos_tragop?.[0]
                                    );
                                    setFieldValue(
                                      withNameSpace("bankAccountNumber", index),
                                      listPos_tragop?.[0]?.property
                                    );
                                    setFieldValue(
                                      withNameSpace("bankName", index),
                                      listPos_tragop?.[0]?.propertyName
                                    );
                                  }
                                }}
                              />
                            )}
                          {/* nếu tổng tiên = tiền cần thu thì disabled input tiền ck ,sau đó lên tooltip báo */}
                          {el?.characteristic ===
                            PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT &&
                            getIn(
                              values,
                              withNameSpace("totalOfMethod", index)
                            ) === 0 ? (
                            <>
                              <Tooltip title="Tổng tiền đã đủ tiền cần thu">
                                <span> {el?.name}</span>
                              </Tooltip>
                            </>
                          ) : (
                            <>{el?.name}</>
                          )}
                          {el?.characteristic === // the
                            PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD && (
                              <IconCardSelect
                                patientId={patientId}
                                values={values}
                              />
                            )}
                          {el?.characteristic === //tien cọc
                            PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT && (
                              <IconDepositSelect
                                patientId={patientId}
                                values={values}
                              />
                            )}

                          {el?.code === //tien khau tru
                            PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE && (
                              <IconTreatmentRetainSelect
                                patientId={patientId}
                                values={values}
                              />
                            )}

                          {el?.code === //tiền dùng điểm
                            PAYMENT_METHOD_CHARACTERISTIC_LOYALTY && (
                              <IconLoyaltySelect
                                patientId={patientId}
                                values={values}
                              />
                            )}

                        </div>
                      </td>

                      <td>
                        <GlobitsVNDCurrencyInput
                          name={withNameSpace("totalOfMethod", index)}
                          disabled={
                            disabled ||
                            el?.characteristic ===
                            PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD ||
                            el?.characteristic ===
                            PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT ||
                            el?.characteristic ===
                            PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT ||
                            el?.code ===
                            PAYMENT_METHOD_CHARACTERISTIC_LOYALTY ||
                            el?.code ===
                            PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
                          }
                          onChange={(e) =>
                            handleChangeTotalOfMethod(e, el, index)
                          }
                        // notDelay
                        />
                      </td>

                      <td>
                        {/* chọn kỳ hạn lãi xuất theo hình thức thanh toán */}
                        {(el?.interestRatePeriods?.length > 0 ||
                          PAYMENT_METHOD_CODES_REQUIRED_INTEREST_RATE?.includes(
                            el?.code
                          )) &&
                          getIn(values, withNameSpace("totalOfMethod", index)) > 0 && (
                            <IconInterestRateSelect
                              index={index}
                              paymentMethod={el}
                              totalOfMethod={getIn(values, withNameSpace("totalOfMethod", index))}
                              nameSpace={nameSpace}
                              parentValues={values}
                              setParentFieldValue={setFieldValue}
                            />
                          )}
                        {(() => {
                          const selectedInterest = getIn(values, `${nameSpace}[${index}]`);
                          if (!selectedInterest || selectedInterest.interestRateType == null) return null;

                          const typeObj = INTEREST_RATE_TYPE.find(t => t.value === selectedInterest.interestRateType);
                          if (!typeObj) return null;

                          let displayStr = typeObj.name;
                          if (selectedInterest.periodMonths != null) {
                            displayStr += ` - Kỳ hạn ${selectedInterest.periodMonths} tháng`;
                          }
                          if (selectedInterest.interestRate != null) {
                            displayStr += ` - Lãi suất ${selectedInterest.interestRate}%`;
                          }
                          return displayStr;
                        })()}
                        {getIn(errors, `${nameSpace}[${index}].interestRatePeriodId`) && (
                          <div className="text-red">
                            {getIn(errors, `${nameSpace}[${index}].interestRatePeriodId`)}
                          </div>
                        )}
                      </td>

                    </tr>

                    {el?.characteristic ===
                      PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT &&
                      getIn(values, withNameSpace("totalOfMethod", index)) !=
                      0 && (
                        <tr>
                          <td colSpan={3}>
                            <GlobitsPagingAutocomplete
                              disabled={disabled}
                              placeholder="Chọn stk"
                              name={withNameSpace("paymentBank", index)}
                              api={pagingExtGlobalProperty}
                              searchObject={{
                                isActive: true,
                                dataType: TYPE_GLOBAL_PROPOTIES_BANK,
                                departmentIds: values?.department
                                  ? [values?.department.id]
                                  : [],
                              }}
                              getOptionLabel={(option) => {
                                return `${option?.propertyName} - ${option?.property}`;
                              }}
                              onChange={(_, value) => {
                                setFieldValue(
                                  withNameSpace("paymentBank", index),
                                  value
                                );
                                setFieldValue(
                                  withNameSpace("bankAccountNumber", index),
                                  value?.property
                                );
                                setFieldValue(
                                  withNameSpace("bankName", index),
                                  value?.propertyName
                                );
                              }}
                            />
                          </td>
                        </tr>
                      )}

                    {el?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS &&
                      getIn(values, withNameSpace("totalOfMethod", index)) !=
                      0 && (
                        <tr>
                          <td colSpan={3}>
                            <GlobitsPagingAutocomplete
                              disabled={disabled}
                              placeholder="Chọn máy pos"
                              name={withNameSpace("paymentBank", index)}
                              api={pagingExtGlobalProperty}
                              searchObject={{
                                isActive: true,
                                dataType: TYPE_GLOBAL_PROPOTIES_POS_LIST,
                                departmentIds: values?.department
                                  ? [values?.department.id]
                                  : [],
                              }}
                              getOptionLabel={(option) => {
                                return `${option?.propertyName} - ${option?.property}`;
                              }}
                              onChange={(_, value) => {
                                setFieldValue(
                                  withNameSpace("paymentBank", index),
                                  value
                                );
                                setFieldValue(
                                  withNameSpace("bankAccountNumber", index),
                                  value?.property
                                );
                                setFieldValue(
                                  withNameSpace("bankName", index),
                                  value?.propertyName
                                );
                              }}
                            />
                          </td>
                        </tr>
                      )}

                    {el?.characteristic ===
                      PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT &&
                      getIn(values, withNameSpace("totalOfMethod", index)) !=
                      0 && (
                        <tr>
                          <td colSpan={2}>
                            <GlobitsPagingAutocomplete
                              disabled={disabled}
                              placeholder="Chọn home credit"
                              name={withNameSpace("paymentBank", index)}
                              api={pagingExtGlobalProperty}
                              searchObject={{
                                isActive: true,
                                dataType:
                                  TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
                                departmentIds: values?.department
                                  ? [values?.department.id]
                                  : [],
                              }}
                              getOptionLabel={(option) => {
                                return `${option?.propertyName} - ${option?.property}`;
                              }}
                              onChange={(_, value) => {
                                setFieldValue(
                                  withNameSpace("paymentBank", index),
                                  value
                                );
                                setFieldValue(
                                  withNameSpace("bankAccountNumber", index),
                                  value?.property
                                );
                                setFieldValue(
                                  withNameSpace("bankName", index),
                                  value?.propertyName
                                );
                              }}
                            />
                          </td>
                        </tr>
                      )}

                    {el?.characteristic ===
                      PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP &&
                      getIn(values, withNameSpace("totalOfMethod", index)) !=
                      0 && (
                        <tr>
                          <td colSpan={2}>
                            <GlobitsPagingAutocomplete
                              disabled={disabled}
                              placeholder="Chọn máy pos vnpay trả góp"
                              name={withNameSpace("paymentBank", index)}
                              api={pagingExtGlobalProperty}
                              searchObject={{
                                isActive: true,
                                dataType:
                                  TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
                                departmentIds: values?.department
                                  ? [values?.department.id]
                                  : [],
                              }}
                              getOptionLabel={(option) => {
                                return `${option?.propertyName} - ${option?.property}`;
                              }}
                              onChange={(_, value) => {
                                setFieldValue(
                                  withNameSpace("paymentBank", index),
                                  value
                                );
                                setFieldValue(
                                  withNameSpace("bankAccountNumber", index),
                                  value?.property
                                );
                                setFieldValue(
                                  withNameSpace("bankName", index),
                                  value?.propertyName
                                );
                              }}
                            />
                          </td>
                        </tr>
                      )}
                  </>
                ) : null
              )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export const IconCardSelect = observer(({ patientId, values }) => {

  const {
    handleOpenClientCardFeePopup,
    openClientCardFeePopup,
    handleCloseClientCardFeePopup,
    initialValueCardFee,
    handleInitCardItemsAndServiceItems,
    handleSubmitTransactionCard,
  } = useStore().feeStore.serviceFeeTabStore;

  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn thẻ">
        <div
          onClick={() => {
            handleOpenClientCardFeePopup({ ...values, patientId });
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openClientCardFeePopup && (
        <SelectCardFeePopup
          open={openClientCardFeePopup}
          handleClose={handleCloseClientCardFeePopup}
          initialValueCardFee={initialValueCardFee}
          handleInitCardItemsAndServiceItems={
            handleInitCardItemsAndServiceItems
          }
          handleSubmit={handleSubmitTransactionCard}
        />
      )}
    </div>
  );
});

const IconDepositSelect = observer(({ patientId, values }) => {
  const {
    handleOpenDepositMoneyFeePopup,
    openDepositMoneyFeePopup,
    handleCloseDepositMoneyFeePopup,
    initialValueDepositMoneyFee,
    handleSubmitTransactionDepositMoney,
    handleInitAdvanceMoneyTransaction,
  } = useStore().feeStore.serviceFeeTabStore;
  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn tiền cọc">
        <div
          onClick={() => {
            handleOpenDepositMoneyFeePopup({ ...values, patientId });
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openDepositMoneyFeePopup && (
        <SelectDepositMoneyFeePopup
          open={openDepositMoneyFeePopup}
          handleClose={handleCloseDepositMoneyFeePopup}
          handleSubmit={handleSubmitTransactionDepositMoney}
          handleInitAdvanceMoneyTransaction={handleInitAdvanceMoneyTransaction}
          initialValueDepositMoneyFee={initialValueDepositMoneyFee}
        />
      )}
    </div>
  );
});

const IconTreatmentRetainSelect = observer(({ patientId, values }) => {
  const {
    handleOpenTreatmentRetainFeePopup,
    openTreatmentRetainFeePopup,
    handleCloseTreatmentRetainFeePopup,
    initialValueTreatmentRetainFee,
    handleSubmitTransactionTreatmentRetain,
    handleInitTreatmentRetainTransaction,
  } = useStore().feeStore.serviceFeeTabStore;
  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn tièn cọc">
        <div
          onClick={() => {
            handleOpenTreatmentRetainFeePopup({ ...values, patientId });
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openTreatmentRetainFeePopup && (
        <SelectTreatmentRetainPopup
          open={openTreatmentRetainFeePopup}
          handleClose={handleCloseTreatmentRetainFeePopup}
          handleSubmit={handleSubmitTransactionTreatmentRetain}
          handleInitTreatmentRetainTransaction={
            handleInitTreatmentRetainTransaction
          }
          initialValueTreatmentRetainFee={initialValueTreatmentRetainFee}
        />
      )}
    </div>
  );
});

const IconLoyaltySelect = observer(({ patientId, values }) => {
  const {
    handleOpenLoyaltyFeePopup,
    openLoyaltyPointFeePopup,
    handleCloseLoyaltyPointFeePopup,
    initialValueLoyaltyPointFee,
    handleSubmitLoyaltyPoint,
    handleInitLoyaltyPoint,
  } = useStore().feeStore.serviceFeeTabStore;
  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn đổi điểm">
        <div
          onClick={() => {
            handleOpenLoyaltyFeePopup({ ...values, patientId });
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openLoyaltyPointFeePopup && (
        <SelectLoyaltyPointPopup
          open={openLoyaltyPointFeePopup}
          handleClose={handleCloseLoyaltyPointFeePopup}
          handleSubmit={handleSubmitLoyaltyPoint}
          handleInitLoyaltyPoint={handleInitLoyaltyPoint}
          initialValueLoyaltyPointFee={initialValueLoyaltyPointFee}
        />
      )}
    </div>
  );
});
const IconInterestRateSelect = observer(({ index, paymentMethod, totalOfMethod, nameSpace, parentValues, setParentFieldValue }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="flex flex-center ml-1">
      <Tooltip title="Thông tin lãi suất">
        <div onClick={() => setOpen(true)}>
          <TouchAppIcon style={{ color: "#ff9800" }} />
        </div>
      </Tooltip>
      {open && (
        <SelectInterestRatePopup
          open={open}
          handleClose={() => setOpen(false)}
          paymentMethod={paymentMethod}
          totalOfMethod={totalOfMethod}
          item={getIn(parentValues, `${nameSpace}[${index}]`)}
          onSave={(localValues) => {
            const basePath = `${nameSpace}[${index}]`;
            const currentItem = getIn(parentValues, basePath);
            const newItem = {
              ...currentItem,
              interestRateType: localValues.interestRateType,
              interestRate: localValues.interestRate,
              periodMonths: localValues.periodMonths,
              interestRatePeriodId: localValues.interestRatePeriodId,
            };
            setParentFieldValue(basePath, newItem);
          }}
        />
      )}
    </div>
  );
});

export default memo(observer(TotalOfVoucherBy));
